export interface PortalActivity {
  id: string;
  title: string;
  dateLabel: string;
  location: string;
  status: 'Intake open' | 'Intake closed' | 'Ready' | 'Completed';
  capacity: number;
  accepted: number;
  waitlisted: number;
  transportConfirmed: number;
  transportSeats: number;
}

export interface PortalMetric {
  label: string;
  value: string;
  tone: 'neutral' | 'positive' | 'attention';
}

export const syntheticPortalActivity: PortalActivity = {
  id: 'act-syn-2026-001',
  title: 'Sunday learning activity',
  dateLabel: 'September 6, 2026 · 8:00 AM',
  location: 'Sample Municipality',
  status: 'Intake open',
  capacity: 30,
  accepted: 18,
  waitlisted: 3,
  transportConfirmed: 14,
  transportSeats: 20,
};

export function buildActivityMetrics(activity: PortalActivity): PortalMetric[] {
  const remainingCapacity = Math.max(activity.capacity - activity.accepted, 0);
  const remainingTransport = Math.max(activity.transportSeats - activity.transportConfirmed, 0);
  return [
    { label: 'Accepted volunteers', value: String(activity.accepted), tone: 'positive' },
    { label: 'Waitlisted', value: String(activity.waitlisted), tone: 'attention' },
    { label: 'Activity places left', value: String(remainingCapacity), tone: 'neutral' },
    { label: 'Transport seats left', value: String(remainingTransport), tone: 'neutral' },
  ];
}
